<template>
  <div class="mobile_render">
    <myHeader />
    <!-- banner模块 -->
    <!-- <div class="banner">
      <p style="font-size: 26px; font-weight: 900">
        Real-time Rendering and Interaction
      </p>
      <p style="font-size: 12px; font-weight: 700; margin-top: 10px">
        Easily build complex and engaging interactive scenes
      </p>
    </div> -->

    <div class="banner">
      <canvas id="threeCanvas" ref="threeCanvas"></canvas>
      <div class="banner_content">
        <p style="font-size: 26px; font-weight: 700" class="banner_content_p">
          Real-time rendering and interaction
        </p>
        <p style="font-size: 12px; font-weight: 700; margin-top: 10px" class="banner_content_p1">
           Easily build complex and engaging interactive scenes 
        </p>
        <div class="callMe" @click="jumpTo('/en/CaseDemonstration#CallMe')">Contact us</div>
      </div>
    </div>

    <!-- 先刷重点模块 -->
    <div class="key_points">
      <p style="font-size: 26px; font-weight: 700; margin-bottom: 10px" class="key_points_p">
         Start by Highlighting the Key Points 
      </p>
      <p style="font-size: 14px; color: rgba(255, 255, 255, 0.64)" class="key_points_p1">
         Advantages of Real-time Rendering and Interaction 
      </p>
      <img v-show="isFirstImage1"
        src="https://download.hecoos.com/enlightv/2025-17/8dc963c65351d2b39e1a034934b48eea.png" alt="" />
      <img v-show="isFirstImage2"
        src="https://download.hecoos.com/enlightv/2025-17/c52ef6a9594d1abf55fea0e923e8117b.png" alt="" />
      <div class="button_container" ref="button_list">
        <button :class="{ btn: true, active: isBtn1Active }" @click="switchContent(1)">
          Real-time Rendering<br />
          Block/SDK
        </button>
        <button :class="{ btn: true, active: isBtn2Active }" @click="switchContent(2)">
          Tracking and Sensor<br /> Integration
        </button>
        <div class="underline" :style="{
          width: buttonUnderlineWidth + 'px',
          left: buttonUnderlineLeft + 'px',
        }"></div>
      </div>
      <div class="render_text">
        <p v-show="isFirstImage1">
          Easily integrate multiple real-time rendering engines (such as
          <span>Notch, Unity3D, Unreal Engine, TouchDesigner,</span> etc.), and
          capture interactive visuals through
          <span>SPOUT, NDI, hardware capture cards,</span> and other methods.
        </p>
        <p v-show="isFirstImage2">
          Data access for the tracking system<span>（VICON, blacktrax, optitrack, stype, Mo-sys, Redspy,
            etc.）</span>Sensor connection<span>(Radar, infrared, pressure sensing, Kinect, etc.)</span>Open source
          hardware interface<span>(ARDUINO, RASPBIAN, etc.)</span>
        </p>
      </div>
    </div>

    <!-- 应用场景模块 -->
    <div class="application_scene">
      <p style="font-size: 26px; margin-bottom: 14px" class="application_scene_p">Application Scenarios</p>
      <p style="font-size: 14px; color: rgba(255, 255, 255, 0.64)" class="application_scene_p1">
        Practical Applications of Real-time Rendering and Interaction
      </p>
      <!-- <mobileRenderBanner :applicationInfo="applicationInfo" /> -->
      <sceneBanner :applicationInfo="applicationInfo" />

    </div>

    <!-- 产品模块 -->
    <div class="product">
      <div class="tab">
        <p style="font-size: 16px" class="default_font tab_p">Product</p>
        <p style="font-size: 26px; font-weight: 700; margin-top: 12px" class="tab_p1">
          Your Real-time Rendering and Interaction Toolkit
        </p>
        <div class="switch" ref="switch_list">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <span :class="{ select: currentTabIndex === 0 }" @click="selectTab(0)">
            <!-- Server-C -->
          </span>
          <span :class="{ select: currentTabIndex === 1 }" @click="selectTab(1)">
            Server-D
          </span>
          <span :class="{ select: currentTabIndex === 2 }" @click="selectTab(2)">
            Server-R
          </span>
          <div class="underline" :style="{
            width: underlineWidth + 'px',
            left: underlineLeft + 'px',
          }"></div>
        </div>
      </div>
      <!-- 产品内容部分 -->
      <div>
        <div class="content">
          <div class="studio" v-show="showContents[0]">
            <img src="https://download.hecoos.com/enlightv/2025-17/04d5ec07fa899de9a432f1229ce2e14a.png" alt="" />
            <div class="textContent">
              <p style="font-size: 20px; font-weight: 700">Server-C</p>
              <p class="render_p">
                Based on the HeCoos workflow, we will manage and control every link from the conception of the
                performance to the final implementation and presentation as much as possible, thereby practicing the
                product design concept of "design is realization".
              </p>
              <button @click="jumpTo('/mediaServer?section=1#tab')">Learn more</button>
            </div>
          </div>
          <div class="studio" v-show="showContents[1]">
            <img src="https://download.hecoos.com/enlightv/2025-17/04d5ec07fa899de9a432f1229ce2e14a.png" alt="" />
            <div class="textContent">
              <p style="font-size: 20px; font-weight: 700">Server-D</p>
              <p class="render_p">
                Relying on the hecoos workflow, we maximize control over every
                aspect from conceptual inspiration to final presentation,
                embodying the product design philosophy of "Design is
                realization.
              </p>
              <button @click="jumpTo('/mediaServer?section=0#tab')">Learn more</button>
            </div>
          </div>
          <div class="studio" v-show="showContents[2]">
            <img src="https://download.hecoos.com/enlightv/2025-17/84ed7b41f8f729ee36615a27ffed63f9.png" alt="" />
            <div class="textContent">
              <p style="font-size: 20px; font-weight: 700">Server-R</p>
              <p class="render_p">
                When confronted with the heavy and complex real-time rendering tasks, the super rendering capability of
                hecoos Server-R can also provide thoughtful support for virtual content creators.
              </p>
              <button @click="jumpTo('/mediaServer?section=2#tab')">Learn more</button>
            </div>
          </div>
        </div>
      </div>
    </div>



    <myCreativity :imgUrl="imgUrl" />
    <myFooter />
  </div>
</template>

<script>
import myHeader from "@/components/en_mobile/myHeader.vue";
import myFooter from "@/components/en_mobile/myFooter.vue";
import sceneBanner from "@/components/en_mobile/scene_banner.vue";
import myCreativity from "@/components/en_mobile/myCreativity.vue";
import G from '@/utils/render_interaction_canvas.js';

export default {
  data() {
    return {
      isFirstImage1: true,
      isFirstImage2: false,
      // 用于控制按钮的激活状态
      isBtn1Active: true,
      isBtn2Active: false,
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 1,
      underlineWidth: 0,
      underlineLeft: 0,
      currentButtonIndex: 1,
      buttonUnderlineWidth: 0,
      buttonUnderlineLeft: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false],
      applicationInfo: [
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/8e0211a35160113c1a748086d6006798.png',
          title: "Concert",
          msg: "hecoos achieves a seamless integration of stunning visual effects and the singer's performance by virtue of its compatibility with multiple real-time rendering engines (such as Notch, Unity3D, Unreal Engine, TouchDesigner, etc.) and precise access to tracking data. This results in an unparalleled multi-sensory feast.",
        },
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/bc8e64755519ac04a0d1b1b398e9af1e.png',
          title: "Stage Performance",
          msg: "When facing the rehearsal interface of hecoos together, artists and engineers can collaborate to discuss and clearly define every detail of the scheme. This lays a solid and reliable foundation for the smooth progress and splendid presentation of the performance.",
        },
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/d464d7fad4f317f5f8e2aa2c6e5d2738.png',
          title: "Immersive Exhibition",
          msg: "HeCoos seamlessly integrates multiple real-time rendering engines with sensors, ingeniously combines them with video, lighting, mechanical and other equipment, and uniformly controls the playback. It builds a creative realization platform for artists, fully unleashing the unlimited potential of artistic creation.",
        },
      ],
      imgUrl: 'https://download.hecoos.com/enlightv/2025-17/519b1d101bbfe0e2b5f382ad27d8202a.png',
    };
  },
  components: {
    myHeader,
    myFooter,
    myCreativity,
    sceneBanner,
  },
  mounted() {
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      this.buttonUpdateUnderlinePosition();
      this.buttonSetupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
      window.addEventListener("resize", this.buttonUpdateUnderlinePosition);
    });
    const canvas = this.$refs.threeCanvas;
    const options = {
      // 这里可以传入自定义参数
    };
    this.threeScene = G(canvas, options);
    this.spheres = this.threeScene.spheres;
  },
  beforeDestroy() {
    if (this.threeScene) {
      this.threeScene.dispose();
    }
    window.removeEventListener("resize", this.updateUnderlinePosition);
    window.removeEventListener("resize", this.buttonUpdateUnderlinePosition);
  },
  methods: {
    jumpTo(path) {
      // console.log(path);
      this.$router.push(path)
    },
    // 导航切换底部跟随
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },

    // 导航切换底部跟随
    buttonUpdateUnderlinePosition() {
      const switchList = this.$refs.button_list;
      if (switchList) {
        const button =
          switchList.querySelectorAll("button")[this.currentButtonIndex - 1];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = button.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(button);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.buttonUnderlineWidth = spanRect.width + paddingLeft - paddingRight;

        // 计算去除 padding 后的左侧偏移量
        this.buttonUnderlineLeft =
          spanRect.left - switchListRect.left - paddingLeft + paddingRight;
      }
    },
    // 文字宽度变化监听
    buttonSetupSpanResizeObservers() {
      const buttons = this.$refs.button_list.querySelectorAll("button");
      const resizeCallback = () => {
        this.buttonUpdateUnderlinePosition();
      };
      buttons.forEach((button) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(button);
      });
    },
    // 切换内容和按钮激活状态的方法
    switchContent(type) {
      this.currentButtonIndex = type;
      this.buttonUpdateUnderlinePosition();
      if (type === 1) {
        this.isFirstImage1 = true;
        this.isFirstImage2 = false;
        this.isBtn1Active = true;
        this.isBtn2Active = false;
      } else {
        this.isFirstImage1 = false;
        this.isFirstImage2 = true;
        this.isBtn1Active = false;
        this.isBtn2Active = true;
      }
    },
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/en_mobile/mobile_xty.scss";
.callMe {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
      background-color: #2a82e4;
      margin: 0 auto;
      color: white;
      text-align: center;
      margin-top: 20px;
      font-size: 12px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
     @media screen and (min-width: 768px) {
      .callMe {
      width: 180px;
      height: 50px;
      line-height: 50px;
      border-radius: 30px;
      background-color: #2a82e4;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 18px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
    }
</style>